<template>
  <div class="home-calculator">
    <div class="container home-calculator-container">
      <div class="home-calculator-description">
        <h2 class="home-calculator-title">
          <span>Para começar, </span>
          <span>precisamos </span>
          entender a sua renda
          <span class="home-calculator--msg">
            Não se preocupe, os dados aqui não são gravados nem usados para outros fins.
          </span>
        </h2>

        <div class="home-calculator-form-container">
          <strong>Quanto você ganha por mês?</strong>
          <p>(some salário, renda de aluguel, aplicações e outras fontes)</p>
          <form class="home-calculator-form" @submit="calculate">
            <input v-model="income" ref="salary" type="text" placeholder="R$ 0,00" />
            <button class="button">Calcular</button>
          </form>
        </div>
      </div>

      <ul class="home-calculator-highlights">
        <li class="home-calculator-highlight">
          <div class="home-calculator-highlight__image">
            <img src="@/assets/images/home/img-home-andreteixeira.png" />
          </div>
          <b class="home-calculator-highlight__credit">
            André Teixeira/Oxfam Brasil
          </b>
        </li>

        <li class="home-calculator-highlight">
          <div class="home-calculator-highlight__image">
            <img src="@/assets/images/home/img-home-paulopereira.png" />
          </div>
          <b class="home-calculator-highlight__credit">
            Paulo Pereira/Oxfam Brasil
          </b>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import VMasker from 'vanilla-masker';

export default {
  data() {
    return {
      income: null,
    };
  },
  mounted() {
    VMasker(this.$refs.salary).maskMoney({
      precision: 2,
      separator: ',',
      unit: 'R$',
    });
  },
  methods: {
    calculate(event) {
      event.preventDefault();

      const sanitizeIncome = this.income.replace(/\D/g, '');

      this.$router.push({
        path: `/resultado/${sanitizeIncome}`,
      });
    },
  },
};
</script>

<style lang="scss">
.home-calculator {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  padding: rem-calc(50 0 30);

  background-color: #aabf0f;

  @media #{$medium-up} {
    padding: rem-calc(100 0);
    // padding-top: $header-height + $footer-height;
    min-height: calc(100vh);
  }
}

.home-calculator-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: auto;

  width: 100%;
  max-width: rem-calc(1005);

  @media #{$medium-up} {
    flex-direction: row;
  }
}

.home-calculator-description {
  width: 100%;
  margin-right: 0;
  margin-bottom: rem-calc(30);

  @media #{$medium-up} {
    margin-right: rem-calc(75);
    margin-bottom: 0;
    max-width: rem-calc(490);
  }
}

.home-calculator-title {
  margin-bottom: rem-calc(25);

  color: $white;
  font-size: rem-calc(18);
  line-height: rem-calc(22);
  font-family: $font-family--header;

  @media #{$medium-up} {
    margin-bottom: rem-calc(70);

    font-size: rem-calc(40);
    line-height: rem-calc(43);
  }

  span {
    display: flex;
  }
}

.home-calculator--msg {
  font-weight: normal;
  font-size: rem-calc(12);
  line-height: rem-calc(18);
  font-family: $font-family--body;

  margin-top: rem-calc(15);

  &:before {
    content: '';
    display: block;
    align-self: center;
    margin-right: rem-calc(15);

    width: rem-calc(25);
    height: 1px;

    background-color: $white;
  }
}

.home-calculator-form-container {
  color: $white;

  strong {
    display: block;
    font-size: rem-calc(18);
    font-weight: normal;

    @media #{$medium-up} {
      font-size: rem-calc(25);
    }
  }

  p {
    font-size: rem-calc(12);
    line-height: rem-calc(18);
    font-weight: normal;

    margin-bottom: rem-calc(20);

    @media #{$medium-up} {
      font-size: rem-calc(16);
      line-height: rem-calc(24);
    }
  }
}

.home-calculator-form {
  input {
    width: 100%;

    padding: rem-calc(10 20);
    margin-right: 0;
    margin-bottom: rem-calc(10);

    color: $minsk;
    font-size: rem-calc(20);
    line-height: rem-calc(24);
    font-weight: 500;

    border: 0;
    border-radius: rem-calc(30);

    @media #{$medium-up} {
      width: auto;

      padding: rem-calc(15 25);
      margin-right: rem-calc(10);
      margin-bottom: 0;
    }
  }

  button {
    width: 100%;
    padding: rem-calc(14 20);

    cursor: pointer;

    transition: color ease 0.3s, background-color ease 0.3s;

    @media #{$medium-up} {
      width: auto;
    }

    &:hover {
      color: $minsk;
      background-color: $turmeric;
    }
  }
}

.home-calculator-highlights {
  display: flex;
  width: 100%;

  @media #{$medium-up} {
    max-width: rem-calc(445);
  }
}

.home-calculator-highlight {
  width: 100%;
  margin-right: rem-calc(30);

  &:last-child {
    margin-right: 0;
  }
}

.home-calculator-highlight__image {
  position: relative;

  width: 100%;
  height: rem-calc(275);

  @media #{$medium-up} {
    height: rem-calc(450);
  }

  @media #{$xlarge-up} {
    height: rem-calc(585);
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;

    width: 100%;
    height: 100%;

    object-fit: cover;
    transform: translate(-50%, -50%);
  }
}

.home-calculator-highlight__credit {
  display: block;
  margin-top: rem-calc(10);

  color: $white;
  font-size: rem-calc(12);
}
</style>
